<template>
  <div class="sidebar-switcher">
    <SelectorOverlayContainer :value="value" horizontal>
      <SelectorOverlayItem
        v-for="item in items"
        :key="item.key"
      >
        <div
          @click="$emit('input', item.key)"
          class="item"
          :class="{ selected: item.key == value }"
        >
          {{ item.label }}
        </div>
      </SelectorOverlayItem>
    </SelectorOverlayContainer>
  </div>
</template>

<script>
import {
  SelectorOverlayItem,
  SelectorOverlayContainer,
} from '@/components/common/selector-overlay'

export default {
  props: {
    items: {},
    value: {},
  },
  created () {
  },
  components: {
    SelectorOverlayItem,
    SelectorOverlayContainer,
  }
}
</script>

<style lang="scss" scoped>

.sidebar-switcher {
  display: flex;
  padding: 0 0 16px;
  flex-direction: row;

  // padding: 10px 20px;
  // background: #fff;
  border-radius: 5px 5px 0px 0px;

  .selector-overlay-item {
    flex-grow: 1;
  }

  .item {
    user-select: none;
    flex-grow: 1;
    height: 30px;
    border: 0;
    font-size: 10px;
    color: #8B8D91;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    &.selected {
      color: #fff;
    }
  }
}

</style>
